import { FinancialDocumentPdfTemplateType } from '@mews-commander/data-access';

export const DEFAULT_ALLOWED_TYPES = [
    FinancialDocumentPdfTemplateType.Detailed,
    FinancialDocumentPdfTemplateType.Consumption,
    FinancialDocumentPdfTemplateType.OrderItem,
    FinancialDocumentPdfTemplateType.Reservation,
    FinancialDocumentPdfTemplateType.Guest,
];
